import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
// import { AppContext } from "../contexts/AppContext";
import { UrlContext } from "../contexts/UrlContext";
import ClientError from "../components/Client/SharedProfiles/clientError";
import ViewProfiles from "../components/Client/SharedProfiles/viewProfiles";
import ProfileViewPage from "../components/Client/SharedProfiles/profileViewPage";
import ShareProfileHeader from "../components/Client/SharedProfiles/shareProfileHeader";
import SharePorfileRow from "../components/Client/SharedProfiles/shareProfilesRow";
import SuggestTimeSlot from "../components/Client/SharedProfiles/suggestTimeSlot";
import { ClientContext } from "../contexts/ClientContext";
import ConsultantLoading from "../components/Client/SharedProfiles/ConsultantLoading";
import SelectProfile from "../components/Client/SharedProfiles/selectProfile";

export default function ClientProfile() {
  const { API_URL } = useContext(UrlContext);
  const projectID = useParams().projectID;
  const [profiles, setProfiles] = useState([]);
  const [project, setProject] = useState("");
  const [projectType, setProjectType] = useState("");
  const [showRow, setShowRow] = useState(true);
  const [showDetails, setShowDetails] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isCalenderOpen, setIsCalendarOpen] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [changedValue, setChangedValue] = useState(null);
  const [sharedProfileSummary, setSharedProfileSummary] = useState("");
  const [singleExpert, setSingleExpert] = useState(false);
  const [allExpert, setAllExpert] = useState(false);
  const [fromRequest, setFromRequest] = useState(false);
  const [showSelectProfile, setShowSelectProfile] = useState(false);
  const [refreshEvent, setRefreshEvent] = useState(false);
  const { isAuthenticated, error, loading, _projectID } =
    useContext(ClientContext);

  useEffect(() => {
    document.title = "Shared Profiles";
  }, []);

  useEffect(() => {
    if (_projectID) {
      getAllSlides();
    }
  }, [_projectID, isAuthenticated, refreshEvent]);

  const getAllSlides = async () => {
    setProfiles([]);
    const requestBody = {
      projectID: _projectID,
    };

    try {
      let modifiedUrl = "fetch-all-slide-data";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const responseData = await response.json();
      if (responseData.status === "success") {
        const modifiedSlideList = responseData.slideList.map((slide) => {
          const totalRating =
            parseInt(slide.rating1) +
            parseInt(slide.rating2) +
            parseInt(slide.rating3) +
            parseInt(slide.rating4) +
            parseInt(slide.rating5);
          const MatchingCo = (totalRating / 25) * 100;
          const chartValue = {
            value: [
              parseInt(slide.rating1),
              parseInt(slide.rating2),
              parseInt(slide.rating3),
              parseInt(slide.rating4),
              parseInt(slide.rating5),
            ],
            badgeValue: `${MatchingCo}%`
          };
          return {
            ...slide,
            chartConfig: chartValue,
          };
        });
        setProfiles(modifiedSlideList);
        setProject(responseData.project);
        setProjectType(responseData.project.projectType);
        setSharedProfileSummary(responseData.sharedProfileSummary);
      } else {
        console.error("Failed to fetch existing expert events");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
  };

  // Api for registering click on profile
  const clickingOnProfile = async (expertID, message) => {
    const token = localStorage.getItem("clientToken");
    const requestBody = {
      projectID: projectID,
      expertID: expertID,
      message: message,
    };
    fetch(`${API_URL}view-consultant-profile-from-cliet-portal`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.status === "success") {
          return;
        } else { return; }
      })
      .catch(() => console.log('Error while registering log') );
  };

  const updateProfilesCallRequested = (selectedExpertIDs = [], value = true) => {
    const selectedIDSet = new Set(
      selectedExpertIDs.map((id) => String(id).trim())
    );

    setProfiles((prevProfiles) =>
      prevProfiles.map((profile) =>
        selectedIDSet.has(String(profile.expertID).trim())
          ? {
              ...profile,
              isCallRequested: value,
            }
          : profile
      )
    );
  };

  return loading ? (
    <ConsultantLoading />
  ) : !isAuthenticated ? (
    <ClientError msg={error} />
  ) : (
    <>
      <ShareProfileHeader
        project={project}
        projectID={projectID}
        profiles={profiles}
        isChanged={isChanged}
        changedValue={changedValue}
        setIsCalendarOpen={setIsCalendarOpen}
        setAllExpert={setAllExpert}
        clickingOnProfile={clickingOnProfile}
        projectType={projectType}
      />

      <div>
        {showRow && (
          <div className="w-full flex flex-col items-center px-3 py-3 mt-2">
            {profiles.map((data, index) => (
              <SharePorfileRow
                key={`${data.projectID}-${data.expertID}`}
                data={data}
                index={index}
                proj_id={projectID}
                expert_id={data?.expertID}
                projectType={projectType}
                setShowRow={setShowRow}
                setShowDetails={setShowDetails}
                setCurrentSlide={setCurrentSlide}
                isCalenderOpen={isCalenderOpen}
                setIsCalendarOpen={setIsCalendarOpen}
                isChanged={isChanged}
                setIsChanged={setIsChanged}
                setChangedValue={setChangedValue}
                setSingleExpert={setSingleExpert}
                setAllExpert={setAllExpert}
                fromRequest={fromRequest}
                setFromRequest={setFromRequest}
                clickingOnProfile={clickingOnProfile}
                profilesList={profiles}
                markProfilesAsCallRequested={updateProfilesCallRequested}
              />
            ))}
          </div>
        )}
        {showDetails && (
          <ProfileViewPage
            expertID={profiles[currentSlide].expertID}
            projectID={projectID}
            profile={profiles[currentSlide]}
            setIsProfileView={setShowDetails}
            projectType={projectType}
            clickingOnProfile={clickingOnProfile}
          />
        )}
        {isCalenderOpen && (
          <SuggestTimeSlot
            projectID={projectID}
            expertID={profiles[currentSlide].expertID}
            profile={profiles[currentSlide]}
            singleExpert={singleExpert}
            setSingleExpert={setSingleExpert}
            allExpert={allExpert}
            setAllExpert={setAllExpert}
            setIsCalendarOpen={setIsCalendarOpen}
            fromRequest={fromRequest}
            setFromRequest={setFromRequest}
            setShowSelectProfile={setShowSelectProfile}
            refreshEvent={refreshEvent}
            setRefreshEvent={setRefreshEvent}
          />
        )}
        {showSelectProfile && (
          <SelectProfile
            projectID={projectID}
            profiles={profiles}
            projectType={projectType}
            setShowSelectProfile={setShowSelectProfile}
            setIsCalendarOpen={setIsCalendarOpen}
            refreshEvent={refreshEvent}
            setRefreshEvent={setRefreshEvent}
          />
        )}
      </div>
    </>
  );
}
